// German number formatting utilities

/**
 * Formats a number with German decimal separator (comma)
 * @param {number} value - The number to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} - Formatted number with German formatting
 */
export const formatGermanDecimal = (value, decimals = 2) => {
  if (isNaN(value) || value === null || value === undefined) {
    return '0,00';
  }
  
  return parseFloat(value).toLocaleString('de-DE', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  });
};

/**
 * Formats a price with German decimal separator and Euro symbol
 * @param {number} value - The price to format
 * @param {number} decimals - Number of decimal places (default: 2)
 * @returns {string} - Formatted price with German formatting and € symbol
 */
export const formatGermanPrice = (value, decimals = 2) => {
  return `${formatGermanDecimal(value, decimals)} €`;
};